require('../styles/main.scss');
// require('foundation-sites')
// const $ = require('jquery');
// global.jQuery = $;


$(document).ready(function () {
  $(document).foundation();
})



/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 2
 ** module chunks = 0
 **/